import Animation from './animation'
import * as d3 from 'd3-selection'

/*
 * This animation is used when we're showing data that is in a tree format.
 * It's used when we have series being removed and those series have a `parentId` that
 * matches a new serie's `id`
 *
 * It's the opposite of the hierarchy-drilldown
 */
class HierarchyDrillupAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = true
    this.ripple = true
    this.positioned = 0
  }

  match (serie) {
    let match = false

    // Calculated breakdown indicating we're showing a bunch of series without a breakdown
    if (this.chart.layout.breakdown.calculated && this.series.size()) {
      // If series are being removed and we're removing all of the series
      if (this.exitingSeries.size() && this.previous.series.size() === this.exitingSeries.size()) {
        // Do any of the exiting series have a parentId
        // Do the new series have a parentId that matches one of the series that's leaving?
        let parentId = this.exitingSeries.selection().data()[0].parentId // We're grabbing the first one, but they should all be the same
          , enteringIds = this.series.selection().data().map(serie => serie.id)

        if (parentId && enteringIds.indexOf(parentId) !== -1) {
          this.parentId = parentId
          match = true
        }
      }
    }

    return match
  }

  animate (serie, entering, selection, merged, exiting) {
    let self = this

    if (++this.positioned === (this.exitingSeries.size() + this.series.size())) {
      // Insert each serie's point into the DOM. We'll fade in them soon
      this.series.each(function (serie) {
        let group = d3.select(this).selectAll('g.rect')
        self._insertHidden(group, serie)
      })

      // Grab the entering serie that matches the `parentId` of the exiting series and store its dimensions
      let parent = this.series.filter(serie => serie.id === this.parentId).selection()
        , dim = this._getDimensions(parent)

      // Collect all the exiting points from each of the old series and form a new selection
      let exit = d3.selectAll(this.exitingSeries.selection().selectAll('g.rect').nodes())
      this._join(exit, dim)

      // Fade in the new nodes
      this.series.selection()
                 .selectAll('g.rect')
                 .transition()
                 .duration(this.totalDuration / 2)
                 .delay(this.totalDuration / 2)
                 .style('opacity', 1)
    }
  }

}

export default HierarchyDrillupAnimation
